import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export const RESULT_ROW_SUBSCRIPTION_HOISTING_EXPERIMENT = 'rovo_fps_hoist_result_row_ui';

/**
 * Evaluates the experiment only when a populated Relay result set can use it. The experimentation
 * SDK handles duplicate calls and exposure caching.
 */
export const useResultRowSubscriptionHoistingExperiment = (shouldEvaluate: boolean): boolean => {
	if (!shouldEvaluate) {
		return false;
	}

	try {
		return isExperimentEnabled(RESULT_ROW_SUBSCRIPTION_HOISTING_EXPERIMENT);
	} catch {
		// An unavailable experimentation client must preserve the legacy control path.
		return false;
	}
};
